import { Button, Flex, Image, Text, TextSize, Weight } from 'components'
import { GLOBAL_COLORS } from 'theme'
import TWITTER_BANNER from 'assets/overview/mobile-twitter-banner.png'
import TwitterIcon from 'assets/overview/x-logo.svg?react'
import WHITEPAPER_BG from 'assets/overview/whitepaper-cta.png'
import styled from 'styled-components'
import BANNER_IMAGE from 'assets/artx-ai-banner-hr-nologo.png'

export const StyledValueText = styled(Text)`
  margin: 5px 0px 5px;
  font-size: ${TextSize.h5};
  ${({ theme }) => theme.mediaWidth.Mobile`font-size: ${TextSize.p};`}
  ${({ theme }) => theme.mediaWidth.Desktop`font-size: ${TextSize.nav};`}
  color: ${({ theme }) => theme.seashellWhiteToDeepOceanBlue};
`

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const CardsList = styled.div`
  display: flex;
  gap: 20px;
  ${({ theme }) => theme.mediaWidth.Desktop`gap: 15px;`}
`

export const Link = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: 0;
  transition: 0.5s ease-in-out;
  ${({ theme }) => theme.mediaWidth.Mobile`margin-top: -20px;`}

  &:hover {
    opacity: 0.6;
  }
`

export const SmallCardItem = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 6px;
`

export const HeaderBox = styled.div`
  margin: 10px 20px 20px;
  ${({ theme }) => theme.mediaWidth.Mobile`margin: 20px 20px 20px;`}
  ${({ theme }) => theme.mediaWidth.Tablet`margin: 20px 0px 20px;`}
`

export const FirstLineText = styled(Text)`
  margin: 10px 0px 5px;
  color: ${({ theme }) => theme.inverseBg};
  opacity: 0.4;
  text-align: center;
`

export const StyledText = styled(Text)`
  font-size: ${TextSize.nav};
  font-weight: ${Weight.SemiBold};
  ${({ theme }) => theme.mediaWidth.Tablet`
    margin-left: 0;
  `}
`

export const IndexCardWrapper = styled.div`
  cursor: pointer;
  flex-grow: 1;
  width: 100%;
  max-width: 412px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    width: 100%;
    max-width: 680px;
  `}
  ${({ theme }) => theme.mediaWidth.Tablet`
    width: 100%;
    max-width: 680px;
`}
  ${({ theme }) => theme.mediaWidth.Desktop`
    width: 300px;
  `}
`

export const SkeletonIndexCardWrapper = styled(IndexCardWrapper)`
  height: 680px;
`

export const SmallCardWrapper = styled.div`
  width: 285px;
  ${({ theme }) => theme.mediaWidth.Desktop`
    width: 265px;
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    width: 250px;
  `}
`
// Still want to scroll, this just hides the bar
const HiddenScrollbar = styled.div`
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &::-webkit-scrollbar {
    width: 1px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
`
export const StyledBigScroll = styled(HiddenScrollbar)`
  min-height: calc(281px - 42px);
  padding: 21px;
  overflow-x: scroll;
  padding-top: 21px;
  ${({ theme }) => theme.mediaWidth.Desktop`
    overflow-x: visible;
  `}
`

export const StyledSmallScroll = styled(HiddenScrollbar)`
  overflow-x: scroll;
  min-height: calc(190px - 42px);
  padding: 21px;
  ${({ theme }) => theme.mediaWidth.Desktop`
    overflow-x: visible;
  `}
`

export const SmallIndexList = styled.div`
  margin-top: -10px;
`

export const OverViewWrapper = styled.div`
  font-weight: ${Weight.Medium};
`

export const MobileOverviewContainer = styled.div``

/**
 * Container arodn the whole ofthe overview page
 */
export const DesktopOverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const SkeletonTitle = styled.div`
  flex: 1;
  max-width: 90px;
`
export const SkeletonPagination = styled.div`
  flex: 1;
  max-width: 70px;
  width: 100%;
`
export const ProductCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  ${({ theme }) => theme.mediaWidth.Tablet`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: calc(680px - 35px);
    margin: 0 20px;
    width: calc(100% - 35px);
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: calc(680px - 35px);
    margin: 0 20px;
    width: calc(100% - 35px);
  `}
  gap: 20px;
`

export const ChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  width: 100%;
  ${({ theme }) => theme.mediaWidth.Tablet`
  flex-direction: column;
  max-width: calc(680px - 35px);
  margin: 0 20px;
  width:calc(100% - 35px)
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
  flex-direction: column;
  max-width: calc(680px - 35px);
  width:calc(100% - 35px)
  `}
`

export const Title = styled.div`
  font-size: ${TextSize.nav};
  font-weight: ${Weight.Medium};
  width: 100%;
  ${({ theme }) => theme.mediaWidth.Tablet`
    width: calc(100% - 35px);
    max-width: calc(680px - 35px);
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
  width: calc(100% - 35px);
  max-width: calc(680px - 35px);
`}
`

export const FullWidthBannerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
export const FullWidthBannerWrapperMobile = styled.div<{ showIndex: boolean }>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  max-width: 600px;
  height: 100px;
  border-radius: 60px;
  margin: 0 auto;
  background-image: url('${({ showIndex }) => (showIndex ? BANNER_IMAGE : TWITTER_BANNER)}');
  background-size: cover;
  @media (max-width: 600px) {
    border-radius: 0px;
  }
`

export const BannerContainer = styled.div`
  max-width: 825px;
  padding: 0 85px;
  margin: 0 auto;
  background-color: green;
`

export const FittedBannerImage = styled(Image)`
  border-radius: 90px;
  width: 1160px;
  margin: auto;
`

export const FittedBannerImageMobile = styled(Image)`
  border-radius: 90px;
  width: 115%;
  margin: auto;
`

export const WhitePaperBanner = styled(Image)`
  border-radius: 200px;
  height: auto;
  width: 1160px;
  margin: auto;
  cursor: pointer;
`

export const ProductDescription = styled.span`
  text-align: center;
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
  line-height: 130%;
  opacity: 0.6;
`

export const IconContainer = styled.div`
  width: 157px;
  height: 92px;
`

export const WhitePaperContainer = styled.div`
  width: 100%;
  max-width: 1156px;
  height: 316px;
  border-radius: 200px;
  margin: auto;
  overflow: hidden;
  @media (max-width: 1060px) {
    border-radius: 0;
  }
`

export const WhitePaperContainerMobile = styled.div`
  width: 100%;
  max-width: 690px;
  height: 316px;
  border-radius: 200px;
  margin: auto;
  overflow: hidden;
  @media (max-width: 689px) {
    border-radius: 0;
  }
`
export const WhitePaperContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #2dc798;
  background-image: url('${WHITEPAPER_BG}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  gap: 20px;
`

export const PartnersBlockContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 470px;
  background-color: ${GLOBAL_COLORS.customBlack};
  gap: 20px;
  border-radius: 230px;
  max-width: 1156px;
  align-self: center;
  margin-top: 60px;
  @media (max-width: 1060px) {
    border-radius: 0;
    margin-top: 0;
  }

  ${({ theme }) => theme.mediaWidth.Tablet`
  width: 100%;
  max-width: 690px;
  border-radius: 230px;
  margin: 60px auto;
`}
  ${({ theme }) => theme.mediaWidth.Mobile`
   max-width: 690px;
   margin: 60px auto;
   border-radius: 230px;
`}
@media (max-width: 689px) {
    border-radius: 0;
    margin-top: 0;
    height: 547px;
  }
`

export const PoweredTitleWrapper = styled(Flex)`
  gap: 10px;
  @media (max-width: 689px) {
    flex-direction: column;
  }
`

export const StyledPoweredTitle = styled(Text)`
  font-size: ${TextSize.h4};
  font-weight: ${Weight.Bold};
  color: ${GLOBAL_COLORS.white};
  max-width: 235px;
  text-align: left;
  @media (max-width: 689px) {
    max-width: 280px;
    text-align: center;
  }
`

export const StyledWhaleImage = styled(Image)`
  height: 64px;
  width: 128px;
  display: flex;
  align-self: center;
  ${({ theme }) => theme.mediaWidth.Small`
    height: 42px;
    width: 84px;
  `}
`

export const DashedLineImage = styled(Image)`
  height: 44px;
  width: 755px;
  ${({ theme }) => theme.mediaWidth.Small`
    height: 42px;
    width: 310px;
`}
`

export const PartnersWrapper = styled(Flex)`
  max-width: 700px;
  justify-content: space-between;
  gap: 30px;
  ${({ theme }) => theme.mediaWidth.Small`
    row-gap: 20px;
    column-gap: 30px;
    max-width: 330px;
    flex-wrap: wrap;
    justify-content: center;
  `}
`

export const PartnerItem = styled(Flex)`
  padding: 15px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 2px solid ${GLOBAL_COLORS.white};
  border-radius: 20px;
  transition: 0.4s all;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
  ${({ theme }) => theme.mediaWidth.Small`
    min-width: 80px;
  `}
`

export const PartnerLogo = styled(Image)`
  height: 48px;
  width: 48px;
  border-radius: 9999px;
  ${({ theme }) => theme.mediaWidth.Small`
    height: 28px;
    width: 28px;
`}
`

export const PartnerName = styled(Text)`
  font-size: 32px;
  font-weight: ${Weight.Bold};
  color: ${GLOBAL_COLORS.white};
  display: inline-flex;
  align-self: center;
  ${({ theme }) => theme.mediaWidth.Small`
    font-size: ${TextSize.nav};
`}
`

export const PartnersBottomText = styled(Text)`
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
  color: ${GLOBAL_COLORS.white};
  max-width: 364px;
  text-align: center;
  ${({ theme }) => theme.mediaWidth.Small`
    max-width: 280px;
`}
`

export const WhitePaperTitle = styled.span`
  color: ${GLOBAL_COLORS.white};
  text-align: center;
  font-size: ${TextSize.h4};
  font-weight: ${Weight.Bold};
  line-height: 104.6%;
  letter-spacing: -1.6px;
  width: 532px;
`

export const WhitePaperDescription = styled.span`
  color: ${GLOBAL_COLORS.white};
  text-align: center;
  font-size: ${TextSize.small};
  line-height: 130%;
  max-width: 387px;
  font-weight: ${Weight.Regular};
`

export const WhitepaperButton = styled(Button)`
  background-color: ${GLOBAL_COLORS.white};
  color: ${GLOBAL_COLORS.whitepaperGreen};
  width: 200px;
  cursor: pointer;
  font-size: ${TextSize.four};
  font-weight: ${Weight.Medium};
  line-height: normal;
  border: 1px solid ${GLOBAL_COLORS.white};
  letter-spacing: -0.14px;
  :hover {
    background-color: ${GLOBAL_COLORS.white};
    color: ${GLOBAL_COLORS.whitepaperGreen};
    border: 1px solid ${GLOBAL_COLORS.white};
  }
`

export const WhitePaperTitleMobile = styled(WhitePaperTitle)`
  text-align: center;
  font-size: ${TextSize.big};
  font-weight: ${Weight.Bold};
  line-height: 110%;
  letter-spacing: -0.64px;
  max-width: 532px;
  width: 100%;
`

export const WhitepaperButtonMobile = styled(WhitepaperButton)`
  width: 156px;
  height: 34px;
`

export const BannerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.white};
`

export const BannerContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: calc(100% - 80px);
  margin: 0 auto;
  align-items: center;
`

export const TwitterLogo = styled(TwitterIcon)`
  width: 35px;
  height: 27px;
  margin-right: 7px;
`

export const IndexLogo = styled(Image)`
  width: 44px;
  height: 44px;
`
export const BannerTitle = styled.div`
  font-size: ${TextSize.nav};
  font-weight: ${Weight.Bold};
  letter-spacing: -0.18px;
`

export const BannerTagLine = styled.div`
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
  line-height: 151.523%;
  letter-spacing: 0.18px;
`
